<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/utils/utils'

const { class: className = '', style = {}, columnId } = defineProps<{
  class?: HTMLAttributes['class'],
  style?: HTMLAttributes['style'],
  columnId?: string,
}>()
</script>

<template>
  <th
    data-slot="table-head"
    :data-column-id="columnId"
    :class="cn('text-muted-foreground h-10 pl-1 pr-0 text-left align-middle text-xs font-medium whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px] overflow-hidden', className)"
    :style="style"
  >
    <slot />
  </th>
</template>
